module.exports = __webpack_public_path__ + "static/media/dotcircle.a2ac20f3.png";